/** Created by azhou on 2018/9/12.*/
<template>
  <!--酒店/民宿用户详细信息-->
  <div class="d-center-start flex-wrap">
    <div class="d-center-start w-50 mb-3"><left-text leftText="联系人"/>{{StoreBasicInfo.contact}}</div>
    <div class="d-center-start w-50 mb-3"><left-text leftText="联系电话"/>{{StoreBasicInfo.mob}}</div>
    <div class="d-center-start w-50 mb-3"><left-text leftText="办公电话"/>{{StoreBasicInfo.tel}}</div>
    <div class="d-center-start w-50 mb-3"><left-text leftText="总机电话"/>
      {{StoreBasicInfo.hotel_tel || StoreBasicInfo.homestay_tel}}
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text leftText="签约类型"/>
      <span class="text-danger" v-if="!StoreBasicInfo.contract">未签约</span>
      <span class="text-blue" v-else>
          {{StoreBasicInfo.contract_arr?StoreBasicInfo.contract_arr.title:''}}（佣金：{{StoreBasicInfo.contract_arr?StoreBasicInfo.contract_arr.yongjin:''}}）
        </span>
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text leftText="活跃值"/>{{StoreBasicInfo.exp}}
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text leftText="可用余额"/>{{StoreBasicInfo.money/100 | formatMoney}} 元
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text leftText="开业时间"/>
      <span v-if="StoreBasicInfo.startdate>0">{{StoreBasicInfo.startdate | formatTimestamp}}</span>
      <span v-else>未设置</span>
    </div>
    <div class="d-center-start w-50 mb-3" v-if="StoreBasicInfo.bankcard_arr">
      <left-text leftText="银行卡信息"/>
      已绑定 <span class="text-link ml-1 mr-1" @click="$emit('showItemDetail','bankcard')">{{StoreBasicInfo.bankcard_arr.length}}</span>张银行卡
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text leftText="最近装修"/>
      <span v-if="StoreBasicInfo.fitmentdate>0">{{StoreBasicInfo.fitmentdate | formatTimestamp}}</span>
      <span v-else>未设置</span>
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text leftText="发票信息"/>
      已添加 <span class="text-link ml-1 mr-1" @click="$emit('showItemDetail','invoice')">{{StoreBasicInfo.invoice}}</span>项发票信息
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text leftText="司陪政策"/>{{StoreBasicInfo.escort_policy || '未添加'}}
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text leftText="门店类型"/>{{StoreBasicInfo.type | formatVar('StyleLabel')}}
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text leftText="最低成团"/>{{StoreBasicInfo.min_team_num|formatVar('minTeamNumArr')}}
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text leftText="装修风格"/>{{StoreBasicInfo.decorate | formatVar('DecorationLabel')}}
    </div>
    <div class="d-center-start w-50 mb-3" v-if="StoreBasicInfo.room_arr">
      <left-text leftText="房型信息"/>
      已上传房型 <span class="text-link ml-1 mr-1" @click="$emit('showItemDetail',{name:'roomList',room_arr:StoreBasicInfo.room_arr})">{{StoreBasicInfo.room_arr.length}}</span>种
    </div>
    <div class="d-center-start w-50 mb-3 flex-wrap" v-if="StoreBasicInfo.type_label">
      <left-text leftText="主题特色"/>
      <span v-if="StoreBasicInfo.features.type_label>0">未设置</span>
      <el-tag type="warning" v-else v-for="item in StoreBasicInfo.type_label" :key="item" class="mr-2 mb-2">{{item | formatVar('TypeLabel')}}</el-tag>
    </div>
    <div class="d-center-start w-50 mb-3" v-if="StoreBasicInfo.meeting_arr">
      <left-text leftText="会议室信息"/>
      已上传会议室 <span class="text-link ml-1 mr-1" @click="$emit('showItemDetail',{name:'meetList',room_arr:StoreBasicInfo.meeting_arr})">{{StoreBasicInfo.meeting_arr.length}}</span>种
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text leftText="早餐种类"/>{{StoreBasicInfo.breakfast_type | formatVar('breakfastTypeArr')}}
    </div>
    <div class="d-center-start w-50 mb-3" v-if="StoreBasicInfo.pic">
      <left-text leftText="门店外观"/>
      已上传<span class="text-link ml-1 mr-1" @click="$emit('showItemDetail','pic')">{{StoreBasicInfo.pic.length}}</span>张
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text leftText="早餐时间"/>{{StoreBasicInfo.breakfast_time || '未设置'}}
    </div>
    <div class="d-center-start w-50 mb-3" v-if="StoreBasicInfo.pic_lobby">
      <left-text leftText="门店内景"/>
      已上传<span class="text-link ml-1 mr-1" @click="$emit('showItemDetail','interiorPic')">{{StoreBasicInfo.pic_lobby.length}}</span>张
    </div>
    <!-- <div class="d-center-start w-50 mb-3">
      <left-text leftText="其他信息"/>
      <span class="mr-2" v-if="StoreBasicInfo.meeting===1">有会议室</span>
      <span v-if="StoreBasicInfo.breakfast===1">有餐饮</span>
    </div> -->
    <div class="d-center-start w-50 mb-3 flex-wrap" v-if="StoreBasicInfo.features">
      <left-text leftText="门店设施"/>
      <span v-if="StoreBasicInfo.features.length>0">未设置</span>
      <el-tag type="success" v-else v-for="item in StoreBasicInfo.features" :key="item" class="mr-2 mb-2">{{item | formatVar('Features')}}</el-tag>
    </div>
    <div class="d-center-start w-50 mb-3" v-if="storeInfo.type===3">
      <left-text leftText="酒店星级"/>
      <el-tag type="success" class="mr-2 mb-2">{{StoreBasicInfo.star | formatVar('HotelStar')}}</el-tag>
    </div>
    <!-- <div class="d-center-start w-50 mb-3" v-if="storeInfo.type == 3 || storeInfo.type == 5">
      <left-text leftText="活动数量"/>
      <label v-if="storeInfo.type == 3">
        <span class="text-link ml-1 mr-1" v-if="StoreBasicInfo.onsaleArr" @click="$emit('showItemDetail','activities')">{{StoreBasicInfo.onsaleArr.onsale_nums}}</span>个
      </label>
      <label v-if="storeInfo.type == 5">
        <span class="text-link ml-1 mr-1" v-if="StoreBasicInfo.onsaleArr" @click="$emit('showItemDetail','homestay')">{{StoreBasicInfo.onsaleArr.onsale_nums}}</span>个
      </label>
    </div> -->
  </div>
</template>

<script>
  import { mapState,mapGetters } from 'vuex'

  export default {
    data () {
      return {
        showIndex: 0,                       //展示酒店/民宿某一项-外景图，内景图，房型信息，会议室信息
        currentRoomMeet: null,             //当前查看的房型/会议室照片
        showRoomMeetIndex: '',              //查看房间会议室照片
        bankcardLists: [],                  //银行卡列表
        invoiceLists: [],                   //发票列表
        type: 0
      }
    },
    watch: {
      StoreBasicInfo () {
        this.StoreBasicInfo.pic_lobby=this.StoreBasicInfo.pic_lobby.split(',');
        this.StoreBasicInfo.pic=this.StoreBasicInfo.pic.split(',');
      },
    },
    computed: {
      ...mapState(['StoreBasicInfo']),
      ...mapGetters(['storeInfo'])
    },
  }
</script>
